"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vipCustomerBenefitsPath = exports.ssoRegisterPath = exports.memberBenefitsPath = exports.getHomeCountryUrl = exports.comparisonPagePath = exports.businessOpportunityPath = void 0;
var _getCountryCode = require("./getCountryCode");
const memberBenefitsPath = exports.memberBenefitsPath = '/member-benefits';
const vipCustomerBenefitsPath = exports.vipCustomerBenefitsPath = '/vip-customer-benefits';
const comparisonPagePath = exports.comparisonPagePath = '/comparison-page';
const businessOpportunityPath = exports.businessOpportunityPath = '/business-opportunity';
const oldRegistrationPaths = [memberBenefitsPath, vipCustomerBenefitsPath, comparisonPagePath, businessOpportunityPath];
const ssoRegisterPath = exports.ssoRegisterPath = '/ssoidentity/register';
/**
 * Returns URL to the home country Oriflame.
 */
const getHomeCountryUrl = ({
  environment = 'live',
  store
}) => {
  const countryCode = (0, _getCountryCode.getCountryCode)();
  const pathname = window.location.pathname
  // remove /[a-z]{2} from the pathname if it is on the first position
  .replace(/^\/[a-z]{2}\//, '/')
  // replace old registration paths with new registration path
  .replace(new RegExp(`^(${oldRegistrationPaths.join('|')})`), ssoRegisterPath);
  const homeCountryUrl = new URL(environment === 'live' ? `https://${countryCode}.oriflame.com${pathname}` : `https://${countryCode}-${environment}.oriflame.com${pathname}`);
  homeCountryUrl.search = window.location.search;
  homeCountryUrl.hash = window.location.hash;
  if (store) {
    // set store query param in URL
    homeCountryUrl.searchParams.set('store', store);
  }
  return homeCountryUrl.toString();
};
exports.getHomeCountryUrl = getHomeCountryUrl;